import './DocumentDownloader.less';
import React from 'react';
import __ from "../../../i18n";
import DocumentHelper from "../../../helpers/DocumentHelper";
import Icon from "../../../../bootstrap/components/icon/Icon";


export default function DocumentDownloader({document}) {

    return <div className="document-downloader">
        <div className="title">{__('Document')}</div>
        <div className="download">
            <Icon name="file"/>
            <a href={DocumentHelper.getUrl(document)} title={document.title} target="_blank">
                {document.title}
            </a>
        </div>
    </div>;
}
